import { render } from "./ItemBurgerButton.vue?vue&type=template&id=40636faa&scoped=true"
import script from "./ItemBurgerButton.vue?vue&type=script&lang=js"
export * from "./ItemBurgerButton.vue?vue&type=script&lang=js"

import "./ItemBurgerButton.vue?vue&type=style&index=0&id=40636faa&scoped=true&lang=css"

import exportComponent from "/Users/anwarfuadi/Documents/nyp/gigihpack.com/fe/gigihpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40636faa"]])

export default __exports__